import { aiConfigApi } from '~/apis/aiConfigApi'

import { useGetAiAgents as _useGetAiAgents } from '@mangovoice/ai-configuration'

export const useGetAiAgents = (pbxId: number | null) =>
  _useGetAiAgents(aiConfigApi, pbxId)
